export default __webpack_public_path__ + "static/media/link-bvn.0c22d7b3.svg";